import React, { useEffect } from "react";
import { Container } from "./Elements/Section";
import { Stars } from "lucide-react";
import { COLOR_ACCENT, COLOR_PRIMARY } from "../config/Constants";

const links = [
  { href: "#services", label: "Services" },
  { href: "#industries", label: "Industries" },
  { href: "#work", label: "Work" },
  { href: "#process", label: "Process" },
  { href: "#engagement", label: "Engagement" },
  { href: "#stack", label: "Tech Stack" },
  { href: "#contact", label: "Contact" },
];

export const Nav = () => {
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href").slice(1);
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-white/70 border-b border-gray-200">
      <Container>
        <nav className="flex h-16 items-center justify-between">
          <a
            href="#home"
            className="flex items-center gap-2 font-bold text-gray-900"
          >
            <Stars
              className="w-6 h-6 text-indigo-600"
              style={{ color: COLOR_ACCENT }}
            />
            <span>SKYENCE</span>
          </a>
          <div className="hidden md:flex items-center gap-6 text-sm">
            {links.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className="text-gray-700 hover:opacity-80 font-medium"
                style={{ color: COLOR_PRIMARY }}
              >
                {label}
              </a>
            ))}
            <a
              href="#contact"
              className="rounded-xl border px-4 py-2 font-semibold hover:bg-gray-50"
              style={{ color: COLOR_PRIMARY, borderColor: COLOR_ACCENT }}
            >
              Contact
            </a>
          </div>
        </nav>
      </Container>
    </header>
  );
};
